export enum MgPagedScrollerMessages {
  FETCH_ERROR = 'Error fetching content',
}
